// extracted by css-extract-rspack-plugin
export default {"container":"R47IT6Lbcf4jgQFT","link":"fnC51ZVq2w_7OM5q"};